export enum PrizeTypeEnum {
  PROMO = 'promocode',
  COUPON = 'coupon',
  CERTIFICATE = 'certificate',
}

type languagePrizeType = {
  ru: string;
  kz: string;
  uz: string;
  kg: string;
};

// INFO: тип, который приходит с бэка
export type PrizeType = {
  name: languagePrizeType;
  description: languagePrizeType;
  icon: string;
  image: string;
  category: PrizeTypeEnum;
  download_prize_array_url: string;
  prize_type_id: number | null;
  created_at: string;
  updated_at: string;
  min_start_date: string;
  max_end_date: string;
};

// INFO: тип, который мы отображаем в таблице (не все данные которые передает нам бэк всегда нужны для отображения)
export type TablePrizeItemType = Pick<PrizeType, 'min_start_date' | 'max_end_date'> & {
  id: number | null;
  name: string;
  type: string;
};

export type PrizeFormType = Pick<PrizeType, 'prize_type_id' | 'min_start_date' | 'max_end_date'> & {
  name_ru: string;
  name_kz: string;
  name_uz: string;
  name_kg: string;
  description_ru: string;
  description_kz: string;
  description_uz: string;
  description_kg: string;
  category: string;
  image: File | string | null;
  icon: File | string | null;
  prize_file: File | null;
  is_generated: boolean;
};
